/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) SC Device Icon component.
 */
export const ScDeviceIcon = (props: IconProps) => {
  // The svg renders smaller on this on so we need to set the default to 40
  const {color, size = IconSize.large, stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 35 20' fill='none'>
      <rect y= '4' width= '18' height= '14' fill={iconColor}/>
      <path d= 'M23.9475 21.8569C26.2652 21.256 28.3162 19.899 29.7755 18.0008C31.2349 16.1026 32.0192 13.7717 32.0041 11.3774C31.9891 8.98311 31.1756 6.66227 29.6925 4.78255C28.2094 2.90283 26.1415 1.57169 23.8164 1 ' stroke={iconColor} strokeWidth= '1.5 ' strokeMiterlimit= '10 '/>
      <path d= 'M21.0749 17.8062C22.5012 17.4413 23.7645 16.61 24.6639 15.4444C25.5634 14.2789 26.0473 12.8461 26.0387 11.3739C26.0301 9.90165 25.5295 8.47462 24.6165 7.31968C23.7034 6.16474 22.4305 5.3482 21 5 ' stroke={iconColor} strokeWidth= '1.5 ' strokeMiterlimit= '10 '/>
    </svg>
  );
};
ScDeviceIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
